import React from 'react';
import { ticaValidationSchema } from '../common/validationSchemas';
import {Form, Formik} from 'formik';
import { ContractorInfo, OfficesList } from '../components/tica'
import {validateAndTouchAllFields} from '../utils/formik';
import { generateTICA } from '../utils/pdfs/tica';
import { ticaInitialValues } from '../common/initialValues';
import {Card, Button} from '../components/UI';
import {Link} from 'react-router-dom';
import { clsx } from 'clsx';
import DatePicker from '../components/UI/DatePicker';

const TICA = () => {
  const documents = [
    { id: 1, name: 'Driver Hiring Packet', to : '/'},
    { id: 2, name: 'TICA', to: '/tica'},
  ]

  return (
    <div className='flex flex-col w-full lg:w-2/5 xl:w-2/3 mx-auto space-y-6 mt-6'>
      <div className='flex space-x-6'>
        <div className='w-full lg:w-1/4'>
          <Card title='Documents'>
            <div className='flex flex-col space-y-2'>
              { documents.map(doc => (
                <Link key={doc.id} to={doc.to} className={clsx('flex py-2 px-4 bg-slate-100 rounded-lg cursor-pointer text-slate-600 font-medium')}>
                  { doc.name }
                </Link>
              )) }
            </div>
          </Card>
        </div>
        <div className='w-full lg:w-3/4'>
          <div className='flex flex-col justify-center h-20 bg-white rounded-md mb-6 px-6 space-y-2'>
            <div className='flex space-x-2 text-xs'>
              <Link to='/' className='text-slate-500'>Documents</Link>
              <span className='text-slate-200'>/</span>
              <Link to='/' className='text-blue-500'>TICA</Link>
            </div>
            <span className='text-xl text-slate-600 font-semibold'>Transportation Independent Contractor Agreement</span>
          </div>

          <Formik
            initialValues={ticaInitialValues}
            validationSchema={ticaValidationSchema}
            onSubmit={(values) => console.log(values)}
          >
            {({ validateForm, setTouched, setFieldValue, values, errors }) => (
              <Form className='space-y-6'>
                <Card title='Contractor Information'>
                  <ContractorInfo />
                </Card>

                <div className='grid grid-cols-3 gap-6'>
                   <div className='col-span-2'>
                     <Card title="Offices">
                       <OfficesList />
                     </Card>
                   </div>

                    <Card title="Effective Date">
                      <DatePicker
                        selected={values.effectiveDate}
                        onSelect={(val: any) => {
                          setFieldValue('effectiveDate', val.toLocaleDateString())
                        }}
                        isInvalid={!!errors.effectiveDate}
                        errorMessage={errors.effectiveDate} />
                    </Card>
                </div>

                <div className="flex justify-end">
                  <Button
                    type="button"
                    size='lg'
                    onClick={() => validateAndTouchAllFields(validateForm, setTouched, values, generateTICA)}
                  >
                    Generate
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default TICA;